import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withCaseDer from '../../common/withCaseDer';
import Bugsnag from '../../helpers/bugsnag';
import { onGoBack } from '../../common/globals';
import DersFilter from '../../components/DersFilter/DersFilter';
import withDerSearchFilter from '../../common/withSearchFilter';
import withDerFilter from '../../common/withDerFilter';
import withDersFilterResult from '../../common/withDersFilterResult';
import MissingEntry from '../../components/Models/MissingEntry';
import { searchDers } from '../../utils/utils';

class SearchDers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      derSearchData: {},
    };
    this.missingEntryModal = null;
  }

  async componentDidMount() {
    try {
      this.missingEntryModal = new window.bootstrap.Modal(window.$('#missingEntryModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _checkValidation = (derSearchData) => {
    try {
      if (Object.keys(derSearchData).length) {
        return !!Object.keys(derSearchData).filter((field) => !!(derSearchData[field].length || (derSearchData[field] !== ''))).length;
      } return false;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onApplySearch = async () => {
    try {
      const {
        setDerFilter, setCaseDer, setDersFilterResults, setLoader, notify, online
      } = this.props;
      const { derSearchData } = this.state;
      _.mapKeys(derSearchData, (value, key) => {
        if (_.isArray(value) && _.isEmpty(value)) delete derSearchData[key];
      });

      _.mapKeys(derSearchData, (value, key) => {
        if (_.isString(value) && _.isEmpty(value)) delete derSearchData[key];
      });

      if (this._checkValidation(derSearchData)) {
        setLoader(true);
        if (online) {
          const derSearchRes = await searchDers(derSearchData);
          const { result, message, status } = derSearchRes;
          if (status && result === 'failure') {
            notify({ type: 'error', message });
            setLoader(false);
            return;
          }

          const derSearch = _.orderBy(derSearchRes.data, ['DateExplanted', 'DERNo'], ['desc', 'desc']);

          if (status && result === 'success') {
            setDersFilterResults(derSearch);
            this._onGoBack();
            setDerFilter(derSearchData);
            setCaseDer('false');
            browserHistory.push('/ders/search-ders/search-results');
          } else {
            notify({ type: 'error', message });
          }
          setLoader(false);
        } else {
          notify({
            type: 'error',
            message: 'You must have as internet connection. Please check your connection and try again.',
            time: 3
          });
        }
      } else {
        // notify({ type: 'error', message: 'You must select at least one search field' });
        this.missingEntryModal.show();
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      this.setState({ derSearchData: data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onReset = () => {
    try {
      const { setDerFilter } = this.props;
      this.setState({ derSearchData: {} });
      setDerFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackDers = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { derFilter, setCaseDer } = this.props;
      setCaseDer('');
      this.setState({ derSearchData: derFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { derSearchData } = this.state;
    const { derFilter } = this.props;
    return (
      <div className="site-wrapper">
        <Header
          actionButton={{ title: 'Apply Search', onClick: this._onApplySearch }}
          title="DERs"
          goBack={this._onGoBackDers}
        />
        <DersFilter
          title="Search DERs"
          filter={{
            patient: true,
          }}
          previousData={derSearchData}
          onFilter={(data) => this._onFilter(data)}
          selectedFilter={derFilter}
          onClearFilter={this._onReset}
        />
        <MissingEntry />
      </div>
    );
  }
}

export default withDerSearchFilter(withDerFilter(withOnline(withGoBack(
  withNotify(withLoader(withCaseDer(withDersFilterResult(SearchDers))))
))));
